<template>
  <v-layout row justify-center class="dialog">
    <v-card>
      <v-dialog persistent v-model="dialogErros" max-width="600px">
        <ModalHistoricoErro
          v-if="dialogErros"
          :dialog="dialogErros"
          @fecharDialogHistoricoErro="dialogErros = false"
          :idApolice="numeroPropostaHistoricoErro"
          :cotacao="true"
          scrollable
        />
      </v-dialog>

      <v-dialog v-model="dialogRecusado" persistent width="400">
        <v-card>

          <v-card-title class="primary">
            <h3 class="headline text-uppercase" style="font-size:18px">APÓLICE RECUSADA</h3>
          </v-card-title>

          <v-card-text>
            <p><span style="font-weight: bold;">Motivo:</span> {{ motivoRecusado.motivoRecusa != null ? motivoRecusado.motivoRecusa : "Esta cotação nao possui motivo de recusa."}}</p>
            <p v-if="motivoRecusado.campoDescricao != null">{{ motivoRecusado.campoDescricao }}</p>
          </v-card-text>
          <v-card-actions style="display: flex; justify-content: flex-end">
            <v-btn flat @click="dialogRecusado = false">
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>

    <v-card class="dialog dialogHistorico">
      <v-card-title class="primary">
        <h3 class="headline text-uppercase ">Histórico de status</h3>
      </v-card-title>
      <v-card-text class="py-5 px-4">
        <div grid-list-md>
          <v-layout wrap>
            <div class="wrapper-head ">
              <div class="proposta-falha" v-if="this.idStatus == statuspropostaEnum.statusProposta.REPROVADA">
                <p>
                  Falha ao emitir a proposta de número {{ this.numeroProposta }}
                </p>
                <h3 class="error-headline">Inconsistências:</h3>
                <v-card
                  style="border: 1px solid #bababa; border-radius: 5px"
                  flat
                >
                  <v-card-text style="padding: 5px 10px; margin: 0">
                    <b>Relatório de erros </b>
                    <br />
                    <v-layout align-center>
                      <v-flex
                        xs7
                        style="padding-top: -5px; margin-top: -5px"
                      ></v-flex>
                      <v-flex
                        text-xs-right
                        xs5
                        style="padding-top: -15px;margin-top: -5px;padding: 0px;margin: 0px;"
                      >
                        <v-tooltip bottom color="blue darken-1">
                          <v-btn
                            v-if="endosso == true"
                            style="padding: -20px 0px 0px 0px;margin: -10px 0px 0px 0px;"
                            slot="activator"
                            icon
                            color="transparent"
                            @click.native="gerarRelatorioErrorEndosso"
                          >
                            <v-icon text-xs-right color="#00456e"
                              >get_app</v-icon
                            >
                          </v-btn>
                          <v-btn
                            v-else-if="cotacao == true"
                            style="padding: -20px 0px 0px 0px; margin: -10px 0px 0px 0px;"
                            slot="activator"
                            icon
                            color="transparent"
                            @click.native="gerarRelatorioErrorApolice"
                          >
                            <v-icon text-xs-right color="#00456e"
                              >get_app</v-icon
                            >
                          </v-btn>
                          <div style="text-align: center">Download</div>
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </div>

              <div class="proposta-aprovada" v-else-if="this.idStatus == statuspropostaEnum.statusProposta.COTACAO">
                <p>
                  Proposta de número {{ this.numeroProposta }} salva com
                  sucesso.
                </p>
              </div>
              <div
                class="proposta-aprovada"
                v-else-if="this.idStatus == statuspropostaEnum.statusProposta.EMITIDA || this.idStatus == statuspropostaEnum.statusProposta.APROVADA"
              >
                <p>
                  Proposta de número {{ this.numeroProposta }} emitida com
                  sucesso.
                </p>
              </div>
            </div>
            <div class="border-separador"></div>
            <div class="wrapper-content">
              <div class="title-historico mt-1">
                <p>Histórico do usuário</p>
              </div>
              <v-data-table
                :headers="headersDialogHistorico"
                :items="historicoDados"
                hide-actions
                item-key="item"
                class="table-grid"
              >
                <template v-slot:items="props">
                  <td>
                    <p>{{ formatarData(props.item.dataHora) }}</p>
                  </td>
                  <td>
                    <p class="text-uppercase">{{ props.item.nomeUsuario }}</p>
                  </td>
                  <td>
                    <p class="text-uppercase" v-if="cotacao == true">
                      {{ formatStatusApolice(props.item.idPropostaStatus) }}
                    </p>
                    <p class="text-uppercase" v-else-if="endosso == true">
                      {{ formatStatusEndosso(props.item.idEndossoStatus) }}
                    </p>
                  </td>
                  <td>
                    <a
                      :class="
                        desabilitarVisualizar(props.item.idPropostaStatus)
                      "
                      @click="abrirdialogHistoricoErro(props.item.idApolice,props.item.idPropostaStatus)"
                    >
                      VISUALIZAR
                    </a>
                  </td>
                </template>
              </v-data-table>
            </div>
          </v-layout>
        </div>
      </v-card-text>
      <v-card-actions class="px-5 pb-5">
        <v-flex class="text-xs-right">
          <v-btn
            class="fechar-dialog elevation-0"
            @click="fecharDialogHistorico"
          >
            Fechar
          </v-btn>
        </v-flex>
      </v-card-actions>
      <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
        {{ snackText }}
        <v-btn flat @click="snack = false">Fechar</v-btn>
      </v-snackbar>
    </v-card>
  </v-layout>
</template>

<script>
import axios from "axios";
import propostaStatusEnum from "@/helpers/tipo-proposta-cotacao.js"
import usuarioHelper from "@/helpers/usuario-logado.js";
import ModalHistoricoErro from "./ModalHistoricoErro.vue";

export default {
  name: "ModalHistorico",
  components: {
    ModalHistoricoErro
  },
  data: () => ({
    headersDialogHistorico: [
      { text: "DATA E HORA", value: "data_hora", sortable: false },
      { text: "USUÁRIO", value: "nome_usuario", sortable: false },
      {
        text: "STATUS",
        value: this.endosso == true ? "idEndossoStatus" : "idPropostaStatus",
        sortable: false
      },
      { text: "MOTIVO", sortable: false }
    ],
    snack: null,
    snackText: null,
    snackColor: null,
    snackbar: {
      visivel: false,
      sucesso: false,
      mensagem: ""
    },
    historicoDados: [],
    dialogErros: false,
    numeroPropostaHistoricoErro: null,
    idPropostaStatus: null,
    dialogRecusado: false,
    motivoRecusado: {
      motivoRecusa: null,
      campoDescricao: null
    }
  }),
  props: {
    idApolice: Number,
    endosso: {
      type: Boolean,
      default: false
    },
    cotacao: {
      type: Boolean,
      default: false
    },
    uuidRevisao: String,
    idRascunho: Number,
    numeroProposta: String,
    idStatus: Number,
    numeroRevisao: Number
  },
  computed: {
    statuspropostaEnum() {
      return propostaStatusEnum;
    }
  },
  mounted() {
    if (this.cotacao == true) {
      this.buscarHistoricoCotacao();
    } else if (this.endosso == true) {
      if (this.idRascunho != null && this.idRascunho !== 0) {
        this.buscarHistoricoEndossoPorRascunho(this.idRascunho);
      } else if (this.uuidRevisao == null) {
        this.buscarEndossoRascunhouuidRevisao();
      } else {
        this.buscarHistoricoEndosso(this.uuidRevisao);
      }
    }
  },
  methods: {
    desabilitarVisualizar(id) {
      if (id !== propostaStatusEnum.statusProposta.REPROVADA && id !== propostaStatusEnum.statusProposta.RECUSADA) {
        return "isDisabled";
      } else {
        return "";
      }
    },
    buscarEndossoRascunhouuidRevisao() {
      const id = this.idRascunho == 0 ? this.numeroRevisao : this.idRascunho
      axios
        .get(
          `${process.env.URL_ENDOSSOMS}/v1/visualizarRascunhoEndosso/${id}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          this.buscarHistoricoEndosso(response.data.uuidRevisao);
        })
        .catch(err => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = "Indentificação não encontrada";
        });
    },
    gerarRelatorioErrorApolice() {
      return axios({
        url:
          `${process.env.URL_APOLICEMS}/v1/gerarErroRespostaApolicePdf/` +
          this.idApolice,
        method: "GET",
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
        }
      })
      .then(response => {
        var blob = new Blob([response.data], { type: "application/pdf" });

        var url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Relatorio-erros.pdf");
        document.body.appendChild(link);
        link.click();
      })
      .catch(error => {
        this.snackbar.visivel = true;
        this.snackbar.sucesso = false;
        this.snackbar.mensagem = "Pdf de Relatorio não localizado";
      });
    },
    gerarRelatorioErrorEndosso() {
      return axios({
        url:
          `${process.env.URL_ENDOSSOMS}/v1/gerarErroRespostaEndossoPdf/` +
          this.numeroRevisao,
        method: "GET",
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
        }
      })
      .then(response => {
        var blob = new Blob([response.data], { type: "application/pdf" });

        var url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Relatorio-erros.pdf");
        document.body.appendChild(link);
        link.click();
      })
      .catch(error => {
        this.snackbar.visivel = true;
        this.snackbar.sucesso = false;
        this.snackbar.mensagem = "Pdf de Relatorio não localizado";
      });
    },
    formatStatusApolice(status) {
      if (status == 1) return "COTAÇÃO";
      if (status == 2) return "PROPOSTA";
      if (status == 3) return "EMITIDA";
      if (status == 4) return "APÓLICE APROVADA";
      if (status == 5) return "APÓLICE REJEITADA";
      if (status == 6) return "APÓLICE RECUSADA";
      if (status == 7) return "CANCELADA";
      if (status == 8) return "PENDENTE";
      if (status == 9) return "EM PROCESSAMENTO";
      if (status == 10) return "EXPIRADA";
      if (status == 11) return "TERMOS DE ACEITE CONFIRMADOS";
      if (status == 12) return "APÓLICE VENCIDA";
      if (status == 13) return "LIBERADA";
      if (status == 14) return "ACEITA";
      if (status == 15) return "CONTESTADA";
      if (status == 16) return "DECLINADA";
      if (status == 17) return "TRANSMITIDA";
    },
    formatStatusEndosso(status) {
      if (status == 1) return "SALVO";
      if (status == 2) return "EMITIDA";
      if (status == 3) return "AG. ENDOSSO";
      if (status == 4) return "ENDOSSO APROVADO";
      if (status == 5) return "ENDOSSO REPROVADO";
      if (status == 6) return "ENDOSSO RECUSADO";
      if (status == 7) return "ENDOSSO CANCELADO";
      if (status == 8) return "PENDENTE";
    },
    fecharDialogHistorico() {
      this.$emit("fecharDialogHistorico");
    },
    formatarData(data) {
      return new Date(data)
        .toLocaleString()
        .replace("T", " ")
        .replaceAll("-", "/");
    },
    buscarHistoricoCotacao() {
      axios
      .get(
        `${process.env.URL_APOLICEMS}/v1/apoliceStatusUsuarioList/${this.idApolice}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      )
      .then(response => {
        this.historicoDados = response.data;
      })
      .catch(err => {
        this.snackbar.visivel = true;
        this.snackbar.sucesso = false;
        this.snackbar.mensagem = "Historio de emissão não encontrado";
      });
    },
    tratamentoAbrirMotivoRecusa(id) {
      this.$store.commit("startLoading");
      axios.get(`${process.env.URL_APOLICEMS}/v1/retornarMotivosRecusa/${id}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      ).then(res => {
        if(res.data) {
          this.motivoRecusado.motivoRecusa = res.data.motivoRecusa.titulo;
          this.motivoRecusado.campoDescricao = res.data.campoDescricao;
        }
      }).catch(err => {
        this.snackbar.visivel = true;
        this.snackbar.sucesso = false;
        this.snackbar.mensagem = "Motivo da recusa não pode ser encontrado";
      })
      this.$store.commit("endLoading");
      this.dialogRecusado = true;
    },
    abrirdialogHistoricoErro(id, status) {
      if(status == propostaStatusEnum.statusProposta.RECUSADA) {
        this.tratamentoAbrirMotivoRecusa(id);
      } else {
        if (id) {
          this.numeroPropostaHistoricoErro = id;
        } else {
          this.numeroPropostaHistoricoErro = "0";
        }
        this.dialogErros = true;
      }
    },

    camposDisabled() {
      return this.idPropostaStatus > propostaStatusEnum.statusProposta.COTACAO;
    },

    fecharDialo0gHistoricoRetornos() {
      this.dialogErros = false;
    },

    buscarHistoricoEndossoPorRascunho(idRascunho) {
      axios
      .get(
        `${process.env.URL_ENDOSSOMS}/v1/endossoStatusUsuarioListPorRascunho/` +
          idRascunho,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      )
      .then(response => {
        this.historicoDados = response.data;
      })
      .catch(err => {
        this.snackbar.visivel = true;
        this.snackbar.sucesso = false;
        this.snackbar.mensagem = "Histórico de emissão não encontrado";
      });
    },
    buscarHistoricoEndosso(uuidRevisao) {
      axios
      .get(
        `${process.env.URL_ENDOSSOMS}/v1/endossoStatusUsuarioList/` +
          uuidRevisao,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      )
      .then(response => {
        this.historicoDados = response.data;
      })
      .catch(err => {
        this.snackbar.visivel = true;
        this.snackbar.sucesso = false;
        this.snackbar.mensagem = "Historio de emissão não encontrado";
      });
    }
  }
};
</script>

<style>
.dialogHistorico .table-grid thead {
  background-color: transparent;
}
.dialogHistorico .table-grid .column {
  color: #333333 !important;
}
.dialogHistorico .theme--light.v-table {
  background-color: transparent;
}
.dialogHistorico .theme--light.v-table tbody tr {
  border: 0;
}
.dialogHistorico
  .theme--light.v-table
  tbody
  tr:hover:not(.v-datatable__expand-row) {
  background-color: transparent;
}
.dialogHistorico .theme--light.v-table tbody tr p {
  margin-bottom: 0;
}
.dialogHistorico table.v-table tbody td {
  height: 26px;
}
.dialogHistorico .theme--light.v-table thead tr:first-child {
  border: 0;
}
.dialogHistorico table.v-table thead tr {
  height: 26px;
}
.dialogHistorico .dialogHistorico .table-grid .column {
  font-weight: bold;
}
.dialogHistorico table.v-table tbody td:first-child {
  padding: 0;
}
.dialogHistorico table.v-table thead th:first-child {
  padding: 0;
}
.dialogHistorico .border-separador {
  border-bottom: 1px solid #d7d7d7;
  margin: 20px 0;
  display: block;
  width: 100%;
}
.dialogHistorico .error-headline {
  color: #333333;
  font-weight: 400;
  font-size: 14px;
  margin-bottom: 10px;
}
.dialogHistorico .headline {
  padding-left: 8px;
  color: #fff;
  font-size: 14px;
}
.dialogHistorico .fechar-dialog {
  color: #00466e;
  box-shadow: 0 !important;
  border: 0;
}
.dialogHistorico .v-btn:not(.v-btn--depressed):not(.v-btn--flat) {
  box-shadow: 0 !important;
}
.dialogHistorico .theme--light.v-btn:not(.v-btn--icon):not(.v-btn--flat) {
  background-color: transparent;
  box-shadow: 0 !important;
}

.btn-dialog-historico-erro {
  border: 0;
  background-color: transparent;
  text-transform: uppercase;
  text-align: center;
  color: #027db4;
  box-shadow: none;
}
.btn-dialog-historico-erro:hover {
  text-decoration: underline;
}
.isDisabled {
  color: gray;
  display: inline-block;
  pointer-events: none;
  text-decoration: none;
}
.dialog {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/frota/ModalHistorico.vue